//Import

/* Common */
import LsacMainLogo from './../assets/images/common/lsacMain.png';
import LsacLogo from './../assets/images/common/lsacLogo.png';
import Close from '../assets/images/common/close.svg';
import downloadIcon from '../assets/images/content/download-icon.png';
import copyIcon from '../assets/images/content/group-link.png';
import editIcon from '../assets/images/student/edit-vendor.svg';
import deactivateIconDisabled from '../assets/images/student/Deactivate-disabled.svg';
import deactivateIcon from '../assets/images/student/deactivate.svg';
import resendInviteIcon from '../assets/images/student/Resend-icon.svg';
import deleteIcon from '../assets/images/common/Delete-blue.svg';
import copyCodeIcon from '../assets/images/common/Copy-code.svg';
import timerIcon from '../assets/images/common/Timer.svg';
import downloadIconEnabled from '../assets/images/common/download_enabled.svg';
import downloadIconDisabled from '../assets/images/common/download_disabled.svg';

/* Subscribers or Students */
import avtarImg from './../assets/images/student/avtar.svg';
import notificationSuccess from './../assets/images/student/ico-success.svg';

/* Card */
import linkIcon from './../assets/images/link/link.png';
import pdfIcon from './../assets/images/content/pdf.png';
import jsonIcon from './../assets/images/content/json.png';
import hyperlinkIcon from './../assets/images/content/link.png';

// MENU
import menuArrow from './../assets/images/student/arrow-right.svg';

// Common
export const LsacMainLogoIcon = LsacMainLogo;
export const LsacLogoIcon = LsacLogo;
export const CloseIcon = Close;
export const DownloadIcon = downloadIcon;
export const CopyIcon = copyIcon;
export const EditIcon = editIcon;
export const DeactivateIconDisabled = deactivateIconDisabled;
export const DeactivateIcon = deactivateIcon;
export const ResendIcon = resendInviteIcon;
export const DeleteIcon = deleteIcon;
export const CopyCodeIcon = copyCodeIcon;
export const TimerIcon = timerIcon;
export const DownloadIconEnabled = downloadIconEnabled;
export const DownloadIconDisabled = downloadIconDisabled;

// Students
export const avtarIcon = avtarImg;
export const notificationSuccessIcon = notificationSuccess;

// Card
export const LinkIcon = linkIcon;
export const PdfIcon = pdfIcon;
export const JsonIcon = jsonIcon;
export const HyperLinkIcon = hyperlinkIcon;

// Arrow

export const MenuArrowIcon = menuArrow;
